import React from 'react';

import CmdIndexTabla from "./CmdIndexTabla";
import CTituloTabla from "./CTituloTabla";


const TTable = ({
                  tHead,
                  listaTR,
                  listItemCmd,
                  filtro,
                  reload,
                  children,
                  barAvance,
                  buscarSec,
                  cssWrapper = "",
                  title = "",
                  secondItem = null
                }) => {
  
  const iconReload = typeof reload === "function" ? reload.isReloading ?
    <i className="fa fa-circle-o-notch fa-spin "/> :
    <i className="fa fa-circle-o-notch "/> : null;
  
  const wrapperBarAvance = !!barAvance ? (
    <div style={{height: "30px", paddingTop: "5px"}}>
      {barAvance}
    </div>
  ) : null;
  
  const CTitle = title ? (<CTituloTabla tituloSeccion={title}/>) : null;
  
  
  const eReload = Boolean(reload)
    ? (<span className="card-header-icon" onClick={() => reload.fn()} title="Recargar todos los datos">
            <span className="icon">{iconReload}</span>
          </span>)
    : null;
  
  return (
    <>
      {CTitle}
      
        <div className="card-header-title" style={{paddingLeft: 0}}>
          <CmdIndexTabla listItemCmd={listItemCmd} cssWrapper={cssWrapper}/>
          {buscarSec}
          {filtro}
        </div>
        {secondItem?<div className="p10T">{secondItem}</div>:null}
        {eReload}
      
      
    
        <div className="table-container">
          {wrapperBarAvance}
          <table className="table is-fullwidth is-striped is-hoverable is-sortable is-fullwidth is-Table1">
            {tHead}
            <tbody>
            {listaTR}
            </tbody>
          </table>
          
          {children}
        
        
      </div>
    </>
  
  );
};

export default TTable